export const DangerousGoodsTabs = {
  EnterDetails: 0,
  Lookup: 1,
} as const;
export type DangerousGoodsTabs =
  (typeof DangerousGoodsTabs)[keyof typeof DangerousGoodsTabs];
